<template>
  <div class="tabbar__container" v-if="$route.meta.tabbar">
    <van-tabbar
      active-color="#F25C62"
      inactive-color="#000"
      :value="$route.name"
      :z-index="9999"
      border
      class="fit__height"
      @change="onChangeHandler"
    >
      <van-tabbar-item v-for="item in tabs" :key="item.id" :name="item.name" :dot="item.dot">
        <span>{{ item.title }}</span>
        <img
          slot="icon"
          :src="
            item.name === $route.name
              ? item.icon && item.icon.active
              : item.icon && item.icon.normal
          "
        />
      </van-tabbar-item>
    </van-tabbar>
    <div class="footer__placeholder"></div>
  </div>
</template>

<script>
import routes from '@/router/routes'

const tabbars = routes
  .filter(route => route.meta && route.meta.tabbar)
  .map(route => ({
    name: route.name,
    path: route.path,
    ...route.meta
  }))

export default {
  name: 'tabbarComponent',
  data: () => ({
    tabs: tabbars
  }),
  created() {
    this.$store.watch(state => {
      this.tabs = tabbars
    })
  },
  methods: {
    onChangeHandler(name) {
      window.scrollTo(0, 0)
      this.$router.replace({
        name
      })
    }
  }
}
</script>

<style lang="less" scoped>
.fit__height {
  padding: 0;
  width: 100%;
  box-sizing: content-box;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.footer__placeholder {
  height: 50px;
  box-sizing: content-box;
  padding-bottom: constant(safe-area-inset-bottom) solid #fff;
  padding-bottom: env(safe-area-inset-bottom) solid #fff;
}
</style>
